import { injectable } from '@servicetitan/react-ioc';
import { CancelToken } from 'axios';

import { HttpClient } from './http-client';

export interface AppointmentDetailsResponse {
    id: number;
    number: string;
    locationId: number;
    jobType: string;
    customerName: string;
    status: string;
    startDate: string;
}

@injectable()
export class AppointmentsApi {
    constructor(private readonly httpClient: HttpClient) {}

    getAppointmentDetails = (id: number, cancellationToken?: CancelToken) => {
        return this.httpClient.get<AppointmentDetailsResponse>(`/api/v1/appointments/${id}`, {
            cancelToken: cancellationToken,
        });
    };
}
